<script lang="ts" setup>
import { User, UserLevel } from '@/models/user.model';
import { Mutations, ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, reactive, watch } from 'vue';
import { useStore } from 'vuex';

const store = useStore<ShiftCMSState & { cs: UsersState }>();

const props = defineProps({
  data: {
    type: Object as PropType<User>,
  },
});

const storeUser = computed<User | null>(() => store.state.cs.user);

const user = reactive<User>({
  id: NEW_ID,
  firstName: '',
  lastName: '',
  deviceID: '',
  email: '',
  level: UserLevel.Device,
  actions: [],
  steps: [],
  stories: [],
  userCo2QuizAnswers: [],
  infographics: [],
  initiatives: [],
  labels: [],
  language: 'nl',
});

watch(
  () => storeUser,
  (v) => {
    Object.assign(user, v);
  },
);

const deleteUser = async () => {
  if (confirm('Are you sure you want to delete this user and all their data')) {
    await store.dispatch(UsersActions.DeleteUser, user);
    store.commit(Mutations.HideDrawer);
    store.dispatch(UsersActions.GetUsers);
  }
};

const deleteUserData = async () => {
  if (confirm(`Are you sure you want to delete this user's data`)) {
    await store.dispatch(UsersActions.DeleteUserData, user);
    store.commit(Mutations.HideDrawer);
    store.dispatch(UsersActions.GetUsers);
  }
};

onMounted(() => {
  if (props.data) {
    Object.assign(user, props.data);

    if (user.id !== NEW_ID) {
      store.dispatch(UsersActions.GetFullUser, user.id);
    }
  }
});
</script>
<template>
  <v-container>
    <h2>Handle the request</h2>

    <v-alert type="warning">
      {{ user.firstName }} {{ user.lastName }} ({{ user.email }}) has requested
      {{
        user.requestedAccountDeletion
          ? 'their account to be deleted'
          : 'their data to be deleted'
      }}
    </v-alert>

    <v-row>
      <v-col col="2"></v-col>
      <v-col v-if="user.id !== -1 && user.requestedAccountDeletion">
        <v-btn class="mt-2" color="warning" @click="deleteUser" block
          >Delete account</v-btn
        >
      </v-col>
      <v-col v-if="user.id !== -1 && user.requestedDataRemoval">
        <v-btn class="mt-2" color="warning" @click="deleteUserData" block
          >Delete data</v-btn
        >
      </v-col>
      <v-col col="2"></v-col>
    </v-row>
  </v-container>
</template>
